export const LIST_INJURY_RECORDS = 'LIST_INJURY_RECORDS'
export const LIST_INJURY_RECORDS_SUCCESS = 'LIST_INJURY_RECORDS_SUCCESS'
export const LIST_INJURY_RECORDS_FAILED = 'LIST_INJURY_RECORDS_FAILED'
